import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// 3.3.1.33 Šifrant zavodov (KGZ)

const KGZ_INSTITUTIONS = Object.freeze([
  { id: 1, name: "Murska Sobota" },
  { id: 2, name: "Ptuj" },
  { id: 3, name: "Celje" },
  { id: 4, name: "Kranj" },
  { id: 5, name: "Ljubljana" },
  { id: 6, name: "Nova Gorica" },
  { id: 7, name: "Kamnik" },
  { id: 8, name: "Neznan" },
  { id: 9, name: "Novo mesto" },
  { id: 10, name: "Neznan" },
  { id: 11, name: "Testna postaja" },
  { id: 12, name: "UL, BF" },
]);

export const getInstitutions = createAsyncThunk(
  "institutions/getInstitutions",
  async (_) => {
    return { data: KGZ_INSTITUTIONS };
  }
);

const institutionSlice = createSlice({
  name: "institutions",
  initialState: {
    institutions: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInstitutions.fulfilled, (state, action) => {
      state.institutions = action.payload.data;
    });
  },
});

export default institutionSlice.reducer;
